// This is the module responsible for making HTTP requests to the
// API server. It handles header setting and processing (which for now,
// is just basically the org hostname header in dev).
// It confirms to the Fetch spec. It is isomorphic.

import fetch from 'cross-fetch' // Isomorphic Polyfill
import { apiUrl } from 'config/constants'
import { isDynamicOrganizationDomain } from 'config/constants/urls'

// Constants

const ORGANIZATION_HEADER_KEY = 'x-organization-id'
const ORGANIZATION_HEADER_VALUE = isDynamicOrganizationDomain
   ? window.sessionStorage.getItem('ORGANIZATION_ID') || process.env.ORGANIZATION_ID
   : null

// Wrapped Fetch Function

const wrappedFetch = async (uri, options = {}) => {
   options.headers = options.headers || {}

   if (isDynamicOrganizationDomain) {
      options.headers[ORGANIZATION_HEADER_KEY] = ORGANIZATION_HEADER_VALUE
   }

   const result = await fetch(`${apiUrl}${uri}`, options)
   return result
}

// Export

export default wrappedFetch
export { ORGANIZATION_HEADER_KEY, ORGANIZATION_HEADER_VALUE }
